import script from "./ProClenyProtected.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProClenyProtected.vue?vue&type=script&setup=true&lang=ts"

import "./ProClenyProtected.vue?vue&type=style&index=0&id=462ee02a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462ee02a"]])

export default __exports__